import React, { useState } from 'react';
import StoreCard from './StoreCard';
import { Grid, Button, Box } from '@mui/material';
import { useGetStores } from '../../../services/stores';
import { useSelector } from 'react-redux';
import { Stack, Typography } from "@mui/material";

import Room_Icon from "../../../images/Room_Icon.png";
import EditIcon from "@mui/icons-material/Edit";
import StorefrontIcon from '@mui/icons-material/Storefront';
import CreateStore from '../Modals/Addstore';
import LoadingCard from '../../../components/Loading';

const StoresIndex = () => {
    const [openCreateStore, setOpenCreateStore] = useState(false);

    const { currentBranch } = useSelector((state) => state.branch);
    const branchId = currentBranch?.id;

    const { stores: mystores, isLoading } = useGetStores(branchId);
    console.log('my stores', mystores);
    const skeletonCount = 6;

    return (
        <div>
            {/* Header */}
            {mystores?.warehouses?.length > 0 &&
                <Box className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-semibold">Stores</h1>
                    <Button
                        variant="contained"
                        onClick={() => setOpenCreateStore(true)}
                    >
                        + Add Store
                    </Button>
                </Box>
            }
            {/* Grid */}
            <Grid container spacing={4}>
                {isLoading
                    ? <div className='h-screen w-full justify-center flex'><LoadingCard /></div>
                    : (mystores?.warehouses?.length === 0 || !mystores) ?
                        <div className='h-screen w-full justify-center flex'>
                            <Stack justifyContent="center" alignItems="center" sx={{ height: 400 }}>
                                <Box>
                                    <img src={Room_Icon} alt="Room Icon"></img>
                                </Box>
                                <Box sx={{ textAlign: "center" }}>
                                    <Typography>
                                        You currently don't have any saved Stores.<br></br>Let's start by
                                        creating a Store
                                    </Typography>
                                </Box>
                                <Box sx={{ mt: 2 }}>
                                    <Button
                                        onClick={() => setOpenCreateStore(true)}
                                        startIcon={
                                            <EditIcon
                                                sx={{
                                                    border: 1,
                                                    borderRadius: 1,
                                                    bgcolor: "white",
                                                    borderColor: "white",
                                                    color: "black",
                                                }}
                                            />
                                        }
                                        disableElevation
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            color: "white",
                                            height: 55,
                                            fontSize: "1rem",
                                        }}
                                    >
                                        Add Store
                                    </Button>

                                </Box>
                            </Stack></div> : mystores?.warehouses?.map((store) => (
                                <Grid item xs={12} sm={6} md={4} key={store.id}>
                                    <StoreCard store={store} />
                                </Grid>
                            ))}
            </Grid>

            {/* Create Store Modal */}
            <CreateStore
                visible={openCreateStore}
                handleCancelButton={() => setOpenCreateStore(false)}
                restaurant_id={branchId}
            />
        </div>
    );
};

export default StoresIndex;
